import * as api from '../Firebase/apiTags'

const USER_TAGS_INIT = 'USER_TAGS_INIT'
const ACTION_TAGS_INIT = 'ACTION_TAGS_INIT'
const TAG_LIST_CHANGED = 'TAG_LIST_CHANGED'

export const userTagsReceive = userTags => {
  return {
    type: USER_TAGS_INIT,
    userTags: userTags
  }
}

export const actionTagsReceive = (actionTags, projectId) => {
  return {
    type: ACTION_TAGS_INIT,
    actionTags: actionTags,
    projectId: projectId
  }
}

export const saveTags = (userTags, actionTags, projectId) => {
  return (dispatch) => {
    api.saveTags(dispatch,  onTagListChanged, userTags, actionTags, projectId)
  }
}

export const onTagListChanged = (userTags, actionTags, projectId) => {
  return {
    type: TAG_LIST_CHANGED,
    userTags: userTags,
    actionTags: actionTags,
    projectId: projectId
  }
}

const initState = {
  userTags: {},
  actionTags: {}
}

export default (state = initState, action) => {
  if (action.type === USER_TAGS_INIT) {
    return Object.assign({}, state, {
      userTags: action.userTags
    })
  }
  if (action.type === ACTION_TAGS_INIT) {
    const { actionTags, projectId } = action
    return {
      userTags: { ...state.userTags },
      actionTags: {
        ...state.actionTags,
        [projectId]: {
          ...actionTags
        }
      }
    }
  }
  if (action.type === TAG_LIST_CHANGED) {
    const { userTags, actionTags, projectId } = action
    return {
      userTags: { ...userTags },
      actionTags: {
        ...state.actionTags,
        [projectId]: {
          ...actionTags
        }
      }
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/tagList.js